import {useTranslation} from "react-i18next";
import classNames from 'classnames';
import React, {memo} from 'react';

import {useActiveItemContext} from "./useActiveItemContext";

import '../style.scss';


const PRICE_DETAILS = [
    {label: "topOffer", key: "top_offer", showKompete: true},
    {label: "collectionFloor", key: "collection_floor", showKompete: true},
    {label: "tokenId", key: "token_id", showKompete: false},
    {label: "lastSale", key: "last_sale", showKompete: true},
];

const BazaarCurrentItemDetails = () => {
    const {isInProgress, data} = useActiveItemContext()
    const {t} = useTranslation()

    return (
        <div className="bazaar_current-item_price-details">
            {PRICE_DETAILS.map(({label, key, showKompete},index) =>
                <PriceDetailRow
                    key={index}
                    label={t(label)}
                    isLoading={isInProgress}
                    showKompete={showKompete}
                    value={data?.details[key]}
                />
            )}
        </div>
    );
};

export default memo(BazaarCurrentItemDetails);

const PriceDetailRow = ({label, value, showKompete, isLoading}) => {
    const priceStyleClass = classNames({skeleton: isLoading});

    return (
        <div className="bazaar_current-item_price-details_item">
            <span>{label}</span>
            <div className={priceStyleClass}>
                {value
                    ? <React.Fragment>
                        <span>{value}</span>
                        <span>{showKompete ? "KOMPETE" : ""}</span>
                    </React.Fragment>
                    : <span>-</span>
                }
            </div>
        </div>
    );
};